import { Text } from "@react-three/drei";

const BostonGeneDescription = () => {
  return (
    <Text
      position={[0, -0.99, 0]}
      rotation-x={-Math.PI / 2}
      fontSize={0.7}
      color="white"
    >
      {[
        "Role: Head of Frontend & Salesforce Development",
        "Period: 2022 July - present",
        "",
        "Tech stack:",
        "React, Redux-toolkit, MobX, TypeScript, Laravel, Statamic",
        "Salesforce, APEX, SOQL, Docker, Kubernetes, CI/CD",
        "",
        "Achievements:",
        "• Doctor portal development",
        "• Websites & Internal systems improvement",
        "• DevOps & Salesforce implementation",
      ].join("\n")}
    </Text>
  );
};

export default BostonGeneDescription;
